export const DateFormat = "YYYY-MM-DD"
export const DateTimeFormat = `${DateFormat} HH:mm:ss`